const middleware = {}

middleware['admin'] = require('../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['conductorSwitch'] = require('../middleware/conductorSwitch.js')
middleware['conductorSwitch'] = middleware['conductorSwitch'].default || middleware['conductorSwitch']

middleware['designersGuard'] = require('../middleware/designersGuard.js')
middleware['designersGuard'] = middleware['designersGuard'].default || middleware['designersGuard']

middleware['enforceUserLocale'] = require('../middleware/enforceUserLocale.js')
middleware['enforceUserLocale'] = middleware['enforceUserLocale'].default || middleware['enforceUserLocale']

middleware['featureGuard'] = require('../middleware/featureGuard.js')
middleware['featureGuard'] = middleware['featureGuard'].default || middleware['featureGuard']

middleware['heroku'] = require('../middleware/heroku.js')
middleware['heroku'] = middleware['heroku'].default || middleware['heroku']

middleware['mateCounters'] = require('../middleware/mateCounters.js')
middleware['mateCounters'] = middleware['mateCounters'].default || middleware['mateCounters']

middleware['myRatings'] = require('../middleware/myRatings.js')
middleware['myRatings'] = middleware['myRatings'].default || middleware['myRatings']

middleware['onlyUnauthenticated'] = require('../middleware/onlyUnauthenticated.js')
middleware['onlyUnauthenticated'] = middleware['onlyUnauthenticated'].default || middleware['onlyUnauthenticated']

middleware['redirectAuthenticatedFromLogin'] = require('../middleware/redirectAuthenticatedFromLogin.js')
middleware['redirectAuthenticatedFromLogin'] = middleware['redirectAuthenticatedFromLogin'].default || middleware['redirectAuthenticatedFromLogin']

middleware['redirectIfNonCustomer'] = require('../middleware/redirectIfNonCustomer.js')
middleware['redirectIfNonCustomer'] = middleware['redirectIfNonCustomer'].default || middleware['redirectIfNonCustomer']

middleware['requireOAuthProfile'] = require('../middleware/requireOAuthProfile.js')
middleware['requireOAuthProfile'] = middleware['requireOAuthProfile'].default || middleware['requireOAuthProfile']

middleware['router'] = require('../middleware/router.js')
middleware['router'] = middleware['router'].default || middleware['router']

middleware['tenderDateSubscription'] = require('../middleware/tenderDateSubscription.js')
middleware['tenderDateSubscription'] = middleware['tenderDateSubscription'].default || middleware['tenderDateSubscription']

export default middleware
